import '../../containers/NewOrder/NewOrder.scss';
import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { FaAngleLeft } from 'react-icons/fa';
import { dataActions } from 'reducers';
import store from 'store';
import CartTable from 'components/CartTable';
import ButtonComponent from 'components/ButtonComponent';
import { useDevice } from 'lib/hooks/useDevice';
import { GA_removeProductsFromCart } from 'lib/gtm-utils';

interface CartProps {
    show: boolean;
    close: () => void;
    goToSummary: () => void;
}

const Cart = (props: CartProps) => {
    const { isDesktop } = useDevice();

    const [clearCart, setClearCart] = useState(false);
    const changeClearCart = () => {
        if (clearCart) setClearCart(false);
        else setClearCart(true);
    };

    return (
        <>
            <Modal show={clearCart} onHide={changeClearCart} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Uwaga</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div style={{ textAlign: 'center' }}>
                        <>
                            <p>Czy na pewno chcesz anulować zamówienie?</p>
                            <p>Spowoduje to wyczyszczenie koszyka</p>
                        </>
                    </div>
                    <div className='NewOrder-summaryCancelConfirm-buttons'>
                        <ButtonComponent
                            marginLeft='0'
                            marginRight='0'
                            width='45%'
                            text='TAK'
                            onClick={() => {
                                GA_removeProductsFromCart(store.getState().data.orders.localCart.productsInLocalCart);
                                store.dispatch(dataActions.clearLocalCart());
                                changeClearCart();
                                props.close();
                            }}
                            onHoverAnimation={3}
                        />
                        <ButtonComponent
                            marginLeft='10%'
                            marginRight='0'
                            width='45%'
                            text='NIE'
                            onClick={changeClearCart}
                            onHoverAnimation={3}
                        />
                    </div>
                </Modal.Body>
            </Modal>
            <Modal show={props.show} onHide={props.close} size='lg' dialogClassName='NewOrder-dialog' centered>
                {isDesktop ? (
                    <>
                        <Modal.Header closeButton className='NewOrder-modal-header'>
                            <Modal.Title>Koszyk</Modal.Title>
                        </Modal.Header>
                        <Modal.Body style={{ paddingTop: '0.5rem' }} className='NewOrder-modal-body'>
                            <CartTable close={props.close} />
                        </Modal.Body>
                    </>
                ) : (
                    <>
                        <Modal.Header>
                            <FaAngleLeft size='40px' onClick={props.close} />
                            <Modal.Title>Koszyk</Modal.Title>
                        </Modal.Header>
                        <Modal.Body style={{ padding: '0' }}>
                            <CartTable close={props.close} />
                        </Modal.Body>
                    </>
                )}
                <Modal.Footer className='NewOrder-modal-footer'>
                    <ButtonComponent
                        text='ANULUJ ZAMÓWIENIE'
                        onClick={changeClearCart}
                        marginLeft='3px'
                        marginTop='0px'
                        marginBottom='0px'
                        variant='danger'
                        brandColoredButton={false}
                        width='250px'
                        height={isDesktop ? '' : '50px'}
                    />
                    <ButtonComponent
                        text='PRZEJDŹ DO PODSUMOWANIA'
                        onClick={props.goToSummary}
                        marginRight='3px'
                        marginTop='0px'
                        marginBottom='0px'
                        width='250px'
                        height={isDesktop ? '' : '50px'}
                    />
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default Cart;
